import React, {useEffect, useState} from 'react';

/**
 * 根据当前时间自动计算
 */
function Demo() {

    let [orders, setOrders] = useState([])

    let [currentTime, setCurrentTime] = useState(new Date().getTime());

    useEffect(() => {

        let timer = setInterval(() => {
            setCurrentTime(new Date().getTime())
        }, 1000)

        return () => {
            clearInterval(timer)
        }

    }, [])

    useEffect(() => {

        // ajax 获取到的订单数据
        let data = [
            {id: 1, createdAt: '2020-04-22 17:01:00'},
            {id: 2, createdAt: '2020-04-22 17:09:00'},
        ]

        setOrders(data)

    }, [])

    let calcTime = (time) => {
        let temp = currentTime - new Date(time).getTime()
        return parseInt(temp / 1000)
    }

    return (
        <div>
            {orders.map((item) => {
                return (
                    <div>
                        订单ID: {item.id} 下单时间: {calcTime(item.createdAt)} 秒前
                    </div>
                )
            })}
        </div>
    );
}

export default Demo;